import { environment } from '@quartz-gov-legacy/environments/environment';
﻿
(function () {
	'use strict';

	angular
        .module('personModule')
        .factory('personService', service);

	service.$inject = ['$http', '$q'];

	function service($http, $q) {
	    var baseUrl = environment.apiUrl + '/Pilot/api/Person';

		var service = { };

		// Get person by id
		service.getPersonByID = function (personId) {
			var reqUrl = baseUrl + '/' + personId;

			return $http.get(reqUrl, { cache: true })
				.then(function (response) {
					return response.data;
				});
		};

		service.getPersonByEmployeeEmail = function (employeeEmail) {
			var reqUrl = baseUrl + '/' + employeeEmail;

			return $http.get(reqUrl)
				.then(function (response) {
					return response.data;
				});
		};

		return service;
	}
})();
